import * as React from "react";
import * as StyledComponent from "@tunnel-components/@sharded/@styled/styled";
import SelectGrid from "@tunnel-components/@sharded/@widgets/select";
import StyledIcon from "@tunnel-components/@sharded/@widgets/icons/component";
import * as shortId from "shortid";
import * as i18next from "i18next";
import * as Enums from "@tunnel-enums/index";
import * as Utils from "@Cyclope-Utils/index";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { any } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (props: any): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */

  const { disabledcamera } = props;
  /**
   * @description : retourne un objet ( utilisateur )
   * @const
   * @name User
   * @type { any  }
   */
  const User: any = Utils.createdUserRoles();
  /**
   * @description : retourne un boolean
   * @const
   * @name authorization
   * @type { boolean  }
   */
  const authorization: boolean = Utils.simpleAuthorizationIsAllowed(User, [
    Enums.AuthorizationRightsEnums.CAMERAEDITEDFIELDS,
  ]);
  const authorizationRemovecamera: boolean = Utils.simpleAuthorizationIsAllowed(
    User,
    [Enums.AuthorizationRightsEnums.CAMERADELECTED]
  );

  const handleChange = (e) => {
    const sanVal = e.currentTarget.value.replace(/[^a-zA-Z0-9-_]/g, "");
    e.currentTarget.value = sanVal;
    props.onChangeCamera(e);
  };

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @infos "https://reactjs.org"
   */

  return (
    <div className="cartBoxIncidents">
      <div className="cart-incident">
        <div className="box-header-custom">
          <div className="box-center-display">
            <div className="left part-left">
              <span style={{ textTransform: "uppercase" }}>
                {disabledcamera
                  ? i18next.t("description")
                  : i18next.t("editer")}
              </span>
            </div>
            <div className="left part-left" style={{ textAlign: "right" }}>
              <div
                onClick={props.onClose}
                className="la-croix"
                title={i18next.t("fermer")}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="descriptionDetailsInfos">
        <div className="extractionInfo left" style={{ width: "50%" }}>
          {false && (
            <div className="titleAction" style={{ marginBottom: "8px" }}>
              <span
                style={{
                  display: "inline-block",
                  width: "80px",
                  marginRight: "5px",
                }}
              >
                {i18next.t("id")} :
              </span>
              <StyledComponent.Container
                style={{ width: "calc( 100% - 86px )" }}
              >
                <StyledComponent.ContainerInput
                  error={false}
                  style={{ height: "35px" }}
                >
                  <StyledComponent.Input
                    type="text"
                    defaultValue={props.idCamera}
                    disabled={true}
                  />
                </StyledComponent.ContainerInput>
              </StyledComponent.Container>
            </div>
          )}
          <div className="titleAction" style={{ marginBottom: "8px" }}>
            <span
              style={{
                display: "inline-block",
                width: "80px",
                marginRight: "5px",
              }}
            >
              {i18next.t("ip")} :
            </span>
            <StyledComponent.Container style={{ width: "calc( 100% - 86px )" }}>
              <StyledComponent.ContainerInput
                error={props.ipCameraBoolean}
                style={{ height: "35px" }}
              >
                <StyledComponent.Input
                  type="text"
                  value={props.ipCamera}
                  name="ipCamera"
                  onChange={props.onChangeCamera}
                  disabled={disabledcamera || !authorization}
                />
              </StyledComponent.ContainerInput>
            </StyledComponent.Container>
          </div>
          <div className="titleAction" style={{ marginBottom: "8px" }}>
            <span
              style={{
                display: "inline-block",
                width: "80px",
                marginRight: "5px",
              }}
            >
              {i18next.t("nom")} :
            </span>
            <StyledComponent.Container style={{ width: "calc( 100% - 86px )" }}>
              <StyledComponent.ContainerInput
                error={props.invalidSynthaxe}
                style={{ height: "35px" }}
              >
                <StyledComponent.Input
                  type="text"
                  value={props.nameCamera}
                  name="nameCamera"
                  onChange={handleChange}
                  disabled={disabledcamera || !authorization}
                  maxLength={20}
                />
              </StyledComponent.ContainerInput>
            </StyledComponent.Container>
          </div>
          <div className="titleAction" style={{ marginBottom: "8px" }}>
            <span
              style={{
                display: "inline-block",
                width: "80px",
                marginRight: "5px",
              }}
            >
              {i18next.t("streamShort")} :
            </span>
            <StyledComponent.Container style={{ width: "calc( 100% - 86px )" }}>
              <StyledComponent.ContainerInput
                error={props.invalidSynthaxe}
                style={{ height: "35px" }}
              >
                <StyledComponent.Input
                  type="text"
                  value={props.stream}
                  name="stream"
                  required={true}
                  onChange={props.onChangeCamera}
                  disabled={disabledcamera || !authorization}
                />
              </StyledComponent.ContainerInput>
            </StyledComponent.Container>
          </div>
          <div className="titleAction" style={{ marginBottom: "8px" }}>
            <span
              style={{
                display: "inline-block",
                width: "80px",
                marginRight: "5px",
              }}
            >
              {i18next.t("type")} :
            </span>
            {disabledcamera && (
              <StyledComponent.Container
                style={{ width: "calc( 100% - 86px )" }}
              >
                <StyledComponent.ContainerInput
                  error={false}
                  style={{ height: "35px" }}
                >
                  <StyledComponent.Input
                    type="text"
                    defaultValue={props.typeCamera}
                    disabled={disabledcamera || !authorization}
                  />
                </StyledComponent.ContainerInput>
              </StyledComponent.Container>
            )}
            {!disabledcamera && (
              <StyledComponent.Container
                style={{ width: "calc( 100% - 86px )" }}
              >
                <SelectGrid
                  style={{ height: "60px" }}
                  error={props.typeCameraError}
                  vue={true}
                  selectedOptions={["Fixe", "Mobile"]}
                  onGetIdentifiantItem={props.onGetTypeValue}
                  placeholder={props.typeCamera}
                />
              </StyledComponent.Container>
            )}
          </div>
          <div className="titleAction" style={{ marginBottom: "8px" }}>
            <span
              style={{
                display: "inline-block",
                width: "80px",
                marginRight: "5px",
              }}
            >
              {i18next.t("vue")} :
            </span>
            {disabledcamera && (
              <StyledComponent.Container
                style={{ width: "calc( 100% - 86px )" }}
              >
                <StyledComponent.ContainerInput
                  error={false}
                  style={{ height: "35px" }}
                >
                  <StyledComponent.Input
                    type="text"
                    defaultValue={props.viewCamera}
                    disabled={disabledcamera || !authorization}
                  />
                </StyledComponent.ContainerInput>
              </StyledComponent.Container>
            )}
            {!disabledcamera && (
              <StyledComponent.Container
                style={{ width: "calc( 100% - 86px )" }}
              >
                <SelectGrid
                  error={props.viewCameraError}
                  style={{ height: "60px" }}
                  vue={true}
                  selectedOptions={["approche", "fuite"]}
                  onGetIdentifiantItem={props.onGetVueValue}
                  placeholder={props.viewCamera}
                />
              </StyledComponent.Container>
            )}
          </div>
          <div className="titleAction" style={{ marginBottom: "8px" }}>
            <span
              style={{
                display: "inline-block",
                width: "80px",
                marginRight: "5px",
              }}
            >
              {i18next.t("section")} :
            </span>
            {disabledcamera && (
              <StyledComponent.Container
                style={{ width: "calc( 100% - 86px )" }}
              >
                <StyledComponent.ContainerInput
                  error={false}
                  style={{ height: "35px" }}
                >
                  <StyledComponent.Input
                    type="text"
                    defaultValue={props.sectionCamera}
                    disabled={disabledcamera || !authorization}
                  />
                </StyledComponent.ContainerInput>
              </StyledComponent.Container>
            )}
            {!disabledcamera && (
              <StyledComponent.Container
                style={{ width: "calc( 100% - 86px )" }}
              >
                <SelectGrid
                  error={props.sectionCameraError}
                  style={{ height: "70px" }}
                  section={true}
                  selectedOptions={props.sections}
                  onGetIdentifiantItem={props.onGetSectionValue}
                  placeholder={props.sectionCamera}
                />
              </StyledComponent.Container>
            )}
          </div>
          <div className="titleAction" style={{ marginBottom: "8px" }}>
            <span
              style={{
                display: "inline-block",
                width: "80px",
                marginRight: "5px",
              }}
            >
              {i18next.t("projet")} :
            </span>
            <StyledComponent.Container style={{ width: "calc( 100% - 86px )" }}>
              <StyledComponent.ContainerInput
                error={false}
                style={{ height: "35px" }}
              >
                <StyledComponent.Input
                  type="text"
                  defaultValue={props.projectCamera}
                  disabled={true}
                />
              </StyledComponent.ContainerInput>
            </StyledComponent.Container>
          </div>
        </div>
        <div className="extractionInfo left" style={{ width: "50%" }}>
          <div className="titleAction" style={{ marginBottom: "8px" }}>
            <span
              style={{
                display: "inline-block",
                width: "80px",
                marginRight: "5px",
              }}
            >
              {i18next.t("statut")} :
            </span>
            <StyledComponent.Container style={{ width: "calc( 100% - 86px )" }}>
              <StyledComponent.ContainerInput
                error={false}
                style={{ height: "35px" }}
              >
                <StyledComponent.Input
                  type="text"
                  defaultValue={props.stateCamera}
                  disabled={true}
                />
              </StyledComponent.ContainerInput>
            </StyledComponent.Container>
          </div>
          <div className="titleAction" style={{ marginBottom: "8px" }}>
            <span
              style={{
                display: "inline-block",
                width: "80px",
                marginRight: "5px",
              }}
            >
              {i18next.t("marque")} :
            </span>
            <StyledComponent.Container style={{ width: "calc( 100% - 86px )" }}>
              <StyledComponent.ContainerInput
                error={false}
                style={{ height: "35px" }}
              >
                <StyledComponent.Input
                  type="text"
                  defaultValue={props.marqueCamera}
                  disabled={true}
                />
              </StyledComponent.ContainerInput>
            </StyledComponent.Container>
          </div>
          <div className="titleAction" style={{ marginBottom: "8px" }}>
            <span
              style={{
                display: "inline-block",
                width: "80px",
                marginRight: "5px",
              }}
            >
              {i18next.t("proxyCode")}
            </span>
            <StyledComponent.Container style={{ width: "calc( 100% - 86px )" }}>
              <StyledComponent.ContainerInput
                error={false}
                style={{ height: "35px" }}
              >
                <StyledComponent.Input
                  type="text"
                  name="proxyCode"
                  value={props.proxyCode}
                  onChange={props.onChangeCamera}
                  disabled={disabledcamera || !authorization}
                />
              </StyledComponent.ContainerInput>
            </StyledComponent.Container>
          </div>
          <div className="titleAction" style={{ marginBottom: "8px" }}>
            <span
              style={{
                display: "inline-block",
                width: "80px",
                marginRight: "5px",
              }}
            >
              {i18next.t("modele")}:
            </span>
            <StyledComponent.Container style={{ width: "calc( 100% - 86px )" }}>
              <StyledComponent.ContainerInput
                error={false}
                style={{ height: "35px" }}
              >
                <StyledComponent.Input
                  type="text"
                  defaultValue={props.modeleCamera}
                  disabled={true}
                />
              </StyledComponent.ContainerInput>
            </StyledComponent.Container>
          </div>
          <div className="titleAction" style={{ marginBottom: "8px" }}>
            <span
              style={{
                display: "inline-block",
                width: "80px",
                marginRight: "5px",
              }}
            >
              {i18next.t("ajoute le")}:
            </span>
            <StyledComponent.Container style={{ width: "calc( 100% - 86px )" }}>
              <StyledComponent.ContainerInput
                error={false}
                style={{ height: "35px" }}
              >
                <StyledComponent.Input
                  type="text"
                  defaultValue={props.createDate}
                  disabled={true}
                />
              </StyledComponent.ContainerInput>
            </StyledComponent.Container>
          </div>
          <div className="titleAction" style={{ marginBottom: "8px" }}>
            <span
              style={{
                display: "inline-block",
                width: "180px",
                marginRight: "5px",
              }}
            >
              {" "}
              {i18next.t("derniere modification")} :
            </span>
            <StyledComponent.Container
              style={{ width: "calc( 100% - 185px )" }}
            >
              <StyledComponent.ContainerInput
                error={false}
                style={{ height: "35px" }}
              >
                <StyledComponent.Input
                  type="text"
                  defaultValue={props.lastUpdateDate}
                  disabled={true}
                />
              </StyledComponent.ContainerInput>
            </StyledComponent.Container>
          </div>
          <div className="titleAction" style={{ marginBottom: "8px" }}>
            <span
              style={{
                display: "inline-block",
                width: "180px",
                marginRight: "5px",
              }}
            >
              {i18next.t("derniere consultation")} :
            </span>
            <StyledComponent.Container
              style={{ width: "calc( 100% - 185px )" }}
            >
              <StyledComponent.ContainerInput
                error={false}
                style={{ height: "35px" }}
              >
                <StyledComponent.Input
                  type="text"
                  defaultValue={props.lastReadDate}
                  disabled={true}
                />
              </StyledComponent.ContainerInput>
            </StyledComponent.Container>
          </div>
        </div>
      </div>
      <div className="cart-incident">
        <div className="box-header-custom">
          <div className="box-center-display">
            <div className="left part-left">
              <span>{i18next.t("INFRASTRUCTURE / SEGMENTATION")}</span>
            </div>
            <div className="left part-left">
              <span
                style={{ float: "right" }}
                onClick={props.onInfrastructureIsOpen}
              >
                <StyledComponent.IconRotate
                  rotates={!props.infrastructureIsOpen}
                  style={{ width: "13px", right: "10px" }}
                >
                  <StyledIcon arrowSeek={true} color="whiteSmoke" />
                </StyledComponent.IconRotate>
              </span>
            </div>
          </div>
        </div>
      </div>
      {props.infrastructureIsOpen && (
        <div className="descriptionDetailsInfos">
          <div className="extractionInfo left" style={{ width: "50%" }}>
            <div className="titleAction" style={{ marginBottom: "8px" }}>
              <span
                style={{
                  display: "inline-block",
                  width: "130px",
                  marginRight: "5px",
                }}
              >
                {i18next.t("infrastructure")} :
              </span>
              <StyledComponent.Container
                style={{ width: "calc( 100% - 135px )" }}
              >
                <StyledComponent.ContainerInput
                  error={false}
                  style={{ height: "35px" }}
                >
                  <StyledComponent.Input
                    type="text"
                    defaultValue={props.infrastructureCamera}
                    disabled={true}
                  />
                </StyledComponent.ContainerInput>
              </StyledComponent.Container>
            </div>
            <div className="titleAction" style={{ marginBottom: "8px" }}>
              <span
                style={{
                  display: "inline-block",
                  width: "130px",
                  marginRight: "5px",
                }}
              >
                {" "}
                {i18next.t("direction")}:
              </span>
              <StyledComponent.Container
                style={{ width: "calc( 100% - 135px )" }}
              >
                <StyledComponent.ContainerInput
                  error={false}
                  style={{ height: "35px" }}
                >
                  <StyledComponent.Input
                    type="text"
                    key={shortId.generate()}
                    defaultValue={props.directionCamera}
                    disabled={true}
                  />
                </StyledComponent.ContainerInput>
              </StyledComponent.Container>
            </div>
          </div>
          <div className="extractionInfo left" style={{ width: "50%" }}>
            <div className="titleAction" style={{ marginBottom: "8px" }}>
              <span
                style={{
                  display: "inline-block",
                  width: "180px",
                  marginRight: "5px",
                }}
              >
                {i18next.t("fonction de calibration")} :
              </span>
              <StyledComponent.Container
                style={{ width: "calc( 100% - 185px )" }}
              >
                <StyledComponent.ContainerInput
                  error={false}
                  style={{ height: "35px" }}
                >
                  <StyledComponent.Input
                    type="text"
                    defaultValue={props.calibrationCamera}
                    disabled={true}
                  />
                </StyledComponent.ContainerInput>
              </StyledComponent.Container>
            </div>
            <div className="titleAction" style={{ marginBottom: "8px" }}>
              <span
                style={{
                  display: "inline-block",
                  width: "180px",
                  marginRight: "5px",
                }}
              >
                {" "}
                {i18next.t("derniere segmentation")} :
              </span>
              <StyledComponent.Container
                style={{ width: "calc( 100% - 185px )" }}
              >
                <StyledComponent.ContainerInput
                  error={false}
                  style={{ height: "35px" }}
                >
                  <StyledComponent.Input
                    type="text"
                    defaultValue={props.lastsegmentationCamera}
                    disabled={true}
                  />
                </StyledComponent.ContainerInput>
              </StyledComponent.Container>
            </div>
          </div>
        </div>
      )}
      <div className="cart-incident">
        <div className="box-header-custom">
          <div className="box-center-display">
            <div className="left part-left">
              <span>{i18next.t("localisation")}</span>
            </div>
          </div>
        </div>
      </div>
      <div className="descriptionDetailsInfos">
        <div className="extractionInfo left" style={{ width: "60%" }}>
          <div className="titleAction" style={{ marginBottom: "8px" }}>
            <span
              style={{
                display: "inline-block",
                width: "240px",
                marginRight: "5px",
              }}
            >
              {" "}
              {i18next.t("localisation lineaire")} :
            </span>
            <StyledComponent.Container
              style={{ width: "calc( 100% - 275px )" }}
            >
              <StyledComponent.ContainerInput
                error={false}
                style={{ height: "35px" }}
              >
                <StyledComponent.Input
                  type="number"
                  name="lineairelocalisationCamera"
                  value={`${props.lineairelocalisationCamera}` === "0" ? "" : `${props.lineairelocalisationCamera}`}
                  onChange={props.onChangeCameraLocalization}
                  disabled={disabledcamera || !authorization}
                />
              </StyledComponent.ContainerInput>
            </StyledComponent.Container>
          </div>
          <div className="titleAction" style={{ marginBottom: "8px" }}>
            <span
              style={{
                display: "inline-block",
                width: "240px",
                marginRight: "5px",
              }}
            >
              {" "}
              {i18next.t("distance max de detection")} :
            </span>
            <StyledComponent.Container
              style={{ width: "calc( 100% - 275px )" }}
            >
              <StyledComponent.ContainerInput
                error={props.less || props.more}
                style={{ height: "35px" }}
              >
                <StyledComponent.Input
                  type="number"
                  name="proposedMaxDistance"
                  key="eudes88_xv??"
                  value={`${props.proposedMaxDistance}` === "0" ? "" : `${props.proposedMaxDistance}`}
                  onChange={props.onChangeCameraLocalization}
                  disabled={
                    disabledcamera || !authorization
                  }
                />
              </StyledComponent.ContainerInput>
            </StyledComponent.Container>
          </div>
        </div>
        <div className="extractionInfo left" style={{ width: "40%" }}>
          <div className="titleAction" style={{ marginBottom: "8px" }}>
            <span
              style={{
                display: "inline-block",
                width: "130px",
                marginRight: "5px",
              }}
            >
              {i18next.t("longitude")} :
            </span>
            <StyledComponent.Container
              style={{ width: "calc( 100% - 135px )" }}
            >
              <StyledComponent.ContainerInput
                error={false}
                style={{ height: "35px" }}
              >
                <StyledComponent.Input
                  type="text"
                  defaultValue={props.longGpsCamera}
                  disabled={true}
                />
              </StyledComponent.ContainerInput>
            </StyledComponent.Container>
          </div>
          <div className="titleAction" style={{ marginBottom: "8px" }}>
            <span
              style={{
                display: "inline-block",
                width: "130px",
                marginRight: "5px",
              }}
            >
              {" "}
              {i18next.t("latitude")} :
            </span>
            <StyledComponent.Container
              style={{ width: "calc( 100% - 135px )" }}
            >
              <StyledComponent.ContainerInput
                error={false}
                style={{ height: "35px" }}
              >
                <StyledComponent.Input
                  type="text"
                  defaultValue={props.latGpsCamera}
                  disabled={true}
                />
              </StyledComponent.ContainerInput>
            </StyledComponent.Container>
          </div>
        </div>
      </div>
      <div className="modalBtn">
        {disabledcamera && authorizationRemovecamera && (
          <span className="borderGradian">
            {" "}
            <span
              className="btnSecondary "
              style={{ backgroundColor: "white", overflow: "visible" }}
              onClick={props.onCloseCamera}
            >
              <span className="textGradianlarge">{i18next.t("supprimer")}</span>
            </span>
          </span>
        )}
        {disabledcamera && !authorizationRemovecamera && (
          <span
            className="btnPrimaryDisabled "
            style={{ overflow: "visible", marginLeft: "5px" }}
          >
            {" "}
            {i18next.t("supprimer")}
          </span>
        )}

        {disabledcamera && authorization && (
          <span className="borderGradian">
            <span
              className="btnSecondary "
              style={{ backgroundColor: "white", overflow: "visible" }}
              onClick={props.onEditeCamera}
            >
              <span className="textGradianlarge">{i18next.t("editer")}</span>
            </span>
          </span>
        )}
        {disabledcamera && !authorization && (
          <span
            className="btnPrimaryDisabled "
            style={{ overflow: "visible", marginLeft: "5px" }}
          >
            {" "}
            {i18next.t("editer")}
          </span>
        )}

        {!disabledcamera && (
          <span className="borderGradian">
            <span
              className="btnSecondary "
              style={{ backgroundColor: "white", overflow: "visible" }}
              onClick={props.onEditeCamera}
            >
              <span className="textGradianlarge">{i18next.t("annuler")}</span>
            </span>
          </span>
        )}
        {!disabledcamera && authorization && (
          <span
            className="btnPrimary "
            style={{ overflow: "visible", marginLeft: "5px" }}
            onClick={props.onUpdateCamera(Number(props.idCamera))}
          >
            {" "}
            {i18next.t("enregistrer")}
          </span>
        )}
        {!disabledcamera && !authorization && (
          <span
            className="btnPrimaryDisabled "
            style={{ overflow: "visible", marginLeft: "5px" }}
          >
            {" "}
            {i18next.t("enregistrer")}
          </span>
        )}
      </div>
    </div>
  );
};

// initialisation des props

Component.defaultProps = {};

export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/camera/details/component.tsx